"use-strict";

import httpClient from "../../../http/httpClient";

const httpStats = (organizerId, tournamentId) => {
  return httpClient(`/stats/organizers/${organizerId}/tournaments/${tournamentId}`);
};

export default {
  loadPositions: (organizerId, tournamentId) =>
    httpStats(organizerId, tournamentId).get("/positions"),
};
